import React from 'react';

function Instructions({ instructions = [], onStepChange, readOnly, hidePlaceholders = false }) {
  const maxSteps = 8;
  const maxCharacters = 140;

  const placeholders = [
    "Instructions Step: 1",
    "Instructions Step: 2",
    "Instructions Step: 3",
    "Instructions Step: 4",
    "Instructions Step: 5",
    "Instructions Step: 6",
    "Instructions Step: 7",
    "Instructions Step: 8",
  ];

  const handleInput = (e, index) => {
    const value = e.target.value.slice(0, maxCharacters);
    onStepChange(index, value);
  };

  return (
    <div className="w-full h-full flex flex-col text-[#5a3e36] pt-[1%] pb-[1%]">
      <label className="text-[clamp(0.7rem,1.1vw,1rem)] font-semibold text-center mb-[1%] leading-tight">
        Instructions:
      </label>

      <div className="flex flex-col justify-between flex-1 overflow-hidden gap-[1%]">
        {placeholders.slice(0, maxSteps).map((placeholder, index) => (
          <div key={index} className="h-[clamp(9.5%,12.5%,11.5%)] min-w-0">
            {readOnly ? (
              <div className="w-full h-full px-[2%] py-[0.5%] text-[clamp(0.65rem,0.95vw,0.875rem)] bg-white border border-[#e0c3a5] rounded leading-tight truncate flex items-start box-border">
                {instructions[index]?.trim()
                || <span className="text-transparent select-none">.</span>}
              </div>
            ) : (
              <textarea
                placeholder={hidePlaceholders ? '' : placeholder}
                value={instructions[index] || ''}
                onChange={(e) => handleInput(e, index)}
                className="min-w-0 w-full h-full px-[2%] py-[0.5%] text-[clamp(0.65rem,0.95vw,0.875rem)] font-sans bg-white border border-[#e0c3a5] rounded box-border resize-none overflow-hidden leading-tight"
                rows={2}
              />
            )}
          </div>
        ))}
      </div>
    </div>
  );
}

export default Instructions;
